import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MediaPictureService } from 'projects/common/services/media-picture.service';

@Component({
  selector: 'offer-multiple-image',
  template: `
    <ng-container *ngIf="mediaKeys">
      <div *ngFor="let mediaKey of mediaKeys" class="offer-card-image-container">
        <img class="offer-card-wow-image" 
          src="{{mediaPictureService.getMediaUrl(mediaKey)}}/100x200?op=TRUNCATE" 
          [alt]="alt">
      </div>
    </ng-container>
  `,
  styleUrls: ['./offer-multiple-image.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OfferMultipleImageComponent {

  @Input() mediaKeys: string[];
  @Input() alt: string;

  constructor(public mediaPictureService: MediaPictureService) { }

}
